// 字幕トラックの一覧化と cue 読み込み。PWA は tracks.json(候補プール)＋subtitles/translation.json(現行) を
// IndexedDB(tracks ストア) に raw 保存している。それらから「選べるトラック一覧」と cue を取り出す。
import { db } from '../lib/db.js'

// 戻り値: [{ id, label, lang, source, key }]（key は tracks ストアのキー）
export async function loadTrackList(hash) {
  const d = await db()
  const out = []
  const raw = await d.get('tracks', `${hash}/tracks.json`)
  if (raw) {
    try {
      const j = JSON.parse(raw)
      for (const t of j.tracks || []) {
        out.push({
          id: t.id,
          label: t.label || t.source || t.id,
          lang: t.lang || '',
          source: t.source || '',
          key: `${hash}/${t.file || 'track-' + t.id + '.json'}`,
        })
      }
    } catch {
      /* noop */
    }
  }
  // プールが無い古い項目は、現行のメイン/翻訳を擬似トラックとして並べる。
  if (!out.length) {
    if (await d.get('tracks', `${hash}/subtitles.json`)) {
      out.push({ id: '__main__', label: 'メイン字幕', lang: '', source: '', key: `${hash}/subtitles.json` })
    }
    if (await d.get('tracks', `${hash}/translation.json`)) {
      out.push({ id: '__trans__', label: '翻訳', lang: '', source: '', key: `${hash}/translation.json` })
    }
  }
  return out
}

export async function loadCuesByKey(key) {
  if (!key) return []
  const raw = await (await db()).get('tracks', key)
  if (!raw) return []
  try {
    const cues = JSON.parse(raw).cues || []
    // start 昇順を保証（描画・二分探索のため）
    return cues.filter((c) => c && typeof c.start === 'number').sort((a, b) => a.start - b.start)
  } catch {
    return []
  }
}

// 既定のメイン/サブ key を決める（保存済み選択 → metaContent → 擬似トラック）。
export function pickMainKey(list, metaContent, savedId) {
  if (savedId === '__none__') return null // ユーザーが「メイン字幕=なし」を明示選択
  return resolveKey(list, savedId) || resolveKey(list, metaContent?.mainTrack) ||
    keyOf(list, '__main__') || (list[0] && list[0].key) || null
}
export function pickSubKey(list, metaContent, savedId) {
  if (savedId === '__none__') return null
  return resolveKey(list, savedId) || resolveKey(list, metaContent?.subTrack) ||
    keyOf(list, '__trans__') || null
}
function resolveKey(list, id) {
  if (!id) return null
  const t = list.find((x) => x.id === id)
  return t ? t.key : null
}
function keyOf(list, id) {
  const t = list.find((x) => x.id === id)
  return t ? t.key : null
}

// cue 配列にオフセット(秒)を適用したコピー。
export function applyOffset(cues, offset) {
  if (!offset) return cues
  return cues.map((c) => ({ ...c, start: c.start + offset, end: c.end + offset }))
}
